export const documentsType = {
  invoiceSale: 'InvoiceSale',
  supportDocument: 'SupportDocument',
  equivalentDocumentSPD: 'EquivalentDocumentSPD',
  payroll: 'Payroll',
};

export const documentsConfigurations = {
  [`${documentsType.invoiceSale}`]: {
    id:1,
    name: 'Factura de venta',
  },
  [`${documentsType.supportDocument}`]: {
    id:5,
    name: 'Documento soporte',
  },
  [`${documentsType.equivalentDocumentSPD}`]: {
    id: 60,
    name: 'Documento equivalente',
  },
  [`${documentsType.payroll}`]: {
    id: 102,
    name: 'Nómina electrónica',
  },
};
